import { styled } from '@superset-ui/core';
import React from 'react';
import Button from '../Button';

interface Props {
    title: string;
    buttonText?: string;
    buttonIcon?: any;
    handleBtnClick?: () => void;
}

const SectionHeader = (props: Props) => {
    const justifyContent = props.buttonText ? 'headerRowJustify' : '';

    const StyledDiv = styled.div`
        display: flex;

        .headerRow {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: ${ props.buttonText ? '.5rem' : '1rem'} 1.4rem;
            border-top: 1px solid #EAEAEA;
            border-bottom: 1px solid #EAEAEA;
        }

        .headerRowJustify {
            justify-content: space-between;
        }

        .headerTitle {
            font-weight: 700;
            font-size: 1rem;
            line-height: 1.1rem;
        }

        .headerBtn {
            display: flex;
            flex-direction: row;
            gap: 0.5em;
            cursor: pointer;
            font-weight: 500;
            font-size: 1rem;
            line-height: 1.3rem;
            color: #0046D9;
        }
    `;

    return (
        <StyledDiv>
            <div className={`headerRow ${justifyContent}`}>
                <div className='headerTitle'>
                    {props.title}
                </div>
                { props.buttonText && props.handleBtnClick && (
                    // <div className='headerBtn' onClick={props.handleBtnClick}>
                    //     { props.buttonIcon && (<img src={props.buttonIcon} alt="" />)}
                    //     <span>{props.buttonText}</span>
                    // </div>
                        <Button showIcon={true} text={props.buttonText} onClick={props.handleBtnClick}/>
                    )
                }
            </div>
        </StyledDiv>
    );
};

export default SectionHeader;